import BaseClass from "../../../util/BaseClass";
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import QueryCriteria from "../../base/QueryCriteria";
import * as filterUtil from "./filterUtil";

export default class FilterModel extends BaseClass {

  _pairs;
  queryCriteriaKey;

  apply() {
    let pairs;
    if (this._pairs) pairs = JSON.parse(JSON.stringify(this._pairs));
    const queryCriteria = this.getQueryCriteria();
    if (queryCriteria) queryCriteria.onFilterPairsChanged(pairs);
  }

  clear() {
    this._pairs = undefined;
    const queryCriteria = this.getQueryCriteria();
    if (queryCriteria) {
      queryCriteria._localPairs = this._pairs;
      queryCriteria.onFilterPairsChanged();
    }
  }

  getQueryCriteria() {
    return QueryCriteria.get(this.queryCriteriaKey);
  }

  init() {
    let pairs;
    const queryCriteria = this.getQueryCriteria();
    if (queryCriteria) pairs = queryCriteria.filterPairs;
    if (pairs) {
      this._pairs = JSON.parse(JSON.stringify(pairs));;
    } else {
      this._pairs = undefined;
    }
    if (queryCriteria) queryCriteria._localPairs = this._pairs;
  }

  makePairs() {
    if (this._pairs) return this._pairs;
    const pairs = [];
    const i18nFields = Context.instance.i18n.filter.fields;
    const queryCriteria = this.getQueryCriteria();
    const source = queryCriteria && queryCriteria.getSource();
    const layer = source && source.layer2D;
    const fields = layer && layer.fields;
    if (!fields) return [];

    const addPair = (fieldName,fieldLabel) => {
      const field = filterUtil.getField(fields,fieldName);
      if (field) {
        const label = fieldLabel || field.alias || field.name;
        const pair = queryCriteria.newFilterPair({
          field: field.name,
          label: label
        });
        pair.id = field.name;
        pairs.push(pair);
      }
    };

    if (queryCriteria.sourceKey === "People") {
      if (!queryCriteria.forUnassignedPeople) {
        addPair(FieldNames.SITE_NAME,i18nFields.site);
        addPair(FieldNames.FACILITY_NAME,i18nFields.facility);
        addPair(FieldNames.LEVEL_NUMBER,i18nFields.level);
      }
      addPair(FieldNames.PEOPLE_ORG_LEVEL_2);
      addPair(FieldNames.PEOPLE_ORG_LEVEL_1);
      addPair(FieldNames.PEOPLE_JOB_TITLE);
    } else if (queryCriteria.sourceKey === "Units") {
      addPair(FieldNames.SITE_NAME,i18nFields.site);
      addPair(FieldNames.FACILITY_NAME,i18nFields.facility);
      addPair(FieldNames.LEVEL_NUMBER,i18nFields.level);
    }

    this._pairs = pairs;
    if (queryCriteria) queryCriteria._localPairs = this._pairs;
    return pairs;
  }

  onPairChanged(id,field,value) {
    const pairs = this._pairs;
    if (Array.isArray(pairs)) {
      pairs.some(pair => {
        if (pair.id === id) {
          pair.value = value;
          return true;
        }
        return false;
      });
    }
  }

}
